import styled from "styled-components";

export const StyledAccountContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const StyledAccountHeader = styled.div`
  display: flex;
  flex-direction: row;
  gap: 6px;
  align-items: center;
  padding: 7px 4px;
  border-bottom: 1px solid #eee;
  padding-bottom: 8px;
`;

export const StyledAvatarContainer = styled.div`
  width: ${({ size = "18px" }) => size};
  height: ${({ size = "18px" }) => size};

  box-sizing: border-box;
  background: ${({ hasBg }) => (hasBg ? "#eee" : "transparent")};
  border-radius: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #344054;
  user-select: none;
  cursor: pointer;
  font-size: 10px;
`;

export const StyledUserInfoContainer = styled.div`
  display: flex;
  gap: 4px;
  flex-direction: column;

  span:first-child {
    font-size: 12px;
  }

  span:last-child {
    font-size: 10px;
    color: #878787;
  }
`;
